/**
 * @generated SignedSource<<16e4b7883910bfff45967c284f6e2c8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GridNoteTemplates$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"GridElementTemplate">;
  readonly " $fragmentType": "GridNoteTemplates";
}>;
export type GridNoteTemplates$key = ReadonlyArray<{
  readonly " $data"?: GridNoteTemplates$data;
  readonly " $fragmentSpreads": FragmentRefs<"GridNoteTemplates">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "GridNoteTemplates",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GridElementTemplate"
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "b9b3075bb156f7aa0088f76dbca50e40";

export default node;
